import type { SVGAttributes } from 'react';
import { useTheme } from 'styled-components';
import type { IconType } from 'react-icons';

import type { Color } from '~constants/theme';

type Props = Omit<SVGAttributes<any>, 'rotate'> & {
  icon: IconType;
  color: Color | 'currentColor';
  size: 'xsmall' | 'small' | 'normal' | 'large' | number;
  rotate?: boolean;
  disabled?: boolean;
};

export default function Icon({
  icon: IconComponent,
  size,
  color,
  rotate,
  disabled,
  ...rest
}: Props) {
  const { sizing, colors } = useTheme();
  const _size = typeof size === 'string' ? sizing.icon[size] : size;

  let iconColor = color === 'currentColor' ? color : colors[color];
  if (disabled) iconColor = colors.muted1;

  return (
    <IconComponent
      {...rest}
      color={iconColor}
      size={_size}
      className={rotate ? 'rotate' : undefined}
    />
  );
}
